module.exports = __webpack_public_path__ + "img/lg_ring_y_l_1_1.a7943153.png";